import { createApi } from '@reduxjs/toolkit/query/react';
import fetchBaseQuery from '../fetchBaseQuery';
import type { GenerateScoreRequest, GenerateScoreResponse, IgnoreAllRequest } from './types';

const scoreApi = createApi({
    reducerPath: 'score',
    baseQuery: fetchBaseQuery(),
    endpoints: (builder) => ({
        ignoreAllIssues: builder.mutation<void, IgnoreAllRequest>({
            query: ({ projectId, keyId, langId }) => ({
                url: `/projects/${projectId}/keys/${keyId}/languages/${langId}/score`,
                method: 'DELETE',
            }),
        }),
        generateScore: builder.mutation<GenerateScoreResponse, GenerateScoreRequest>({
            query: ({ projectId, keyId, langId, segmentId, referenceLangId }) => ({
                url: `/projects/${projectId}/keys/${keyId}/languages/${langId}/lqa-report`,
                method: 'POST',
                body: {
                    segmentId,
                    sourceLanguageId: referenceLangId,
                },
            }),
        }),
    }),
});

export default scoreApi;

export const { useIgnoreAllIssuesMutation, useGenerateScoreMutation } = scoreApi;
